export default __webpack_public_path__ + "2a3b1d23750f9de65d5475be7c89b68f.svg";